const consulta_retrato_matricula_por_escola = {
  path: "/consultar_retrato_da_matricula_por_escola",
  redirect: "/consultar_retrato_da_matricula_por_escola",
  meta: {
    breadCrumb:
      "Planejamento da Matrícula - Consultar o Retrato da Matrícula por Escola",
  },
  children: [
    {
      path: "/consultar_retrato_da_matricula_por_escola",
      name: "consultar_retrato_da_matricula_por_escola",
      component: () =>
        import(
          "@/views/ConsultarRetratoDaMatriculaPorEscola/ConsultarRetratoDaMatriculaPorEscola.vue"
        ),
    },
    {
      path: "/consultar_retrato_da_matricula_por_escola/detalhes/:id",
      name: "consultar_retrato_da_matricula_por_escola_detalhes",
      component: () =>
        import(
          "@/views/ConsultarRetratoDaMatriculaPorEscola/ConsultarRetratoDaMatriculaPorEscolaDetalhes.vue"
        ),
    },
  ],
};

export { consulta_retrato_matricula_por_escola };
